import React from "react";

const ScrollDisabledNumberInput = ({ children, ...props }) => {
  const handleWheel = (e) => {
    if (e.target.type === "number") {
      e.target.blur();
    }
  };

  return React.cloneElement(children, {
    onWheel: handleWheel,
    ...props,
  });
};

export default ScrollDisabledNumberInput;
